export default __webpack_public_path__ + "06fc828128c89eacf77cf65838ccdf21.svg";